import React, { useMemo } from 'react';
import { partition, reverse, sortBy } from 'lodash';
import { Classable, Entity, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { classNames } from '@shapeable/utils';
import { PageKnowledgeHubLayout, PageKnowledgeHubLayoutProps, useFeedEntries, usePosts, useVideos } from '@shapeable/ui';

const cls = classNames('slice-knowledge-hub-layout');

export type SliceKnowledgeHubLayoutProps = Classable & HasChildren & {
  entity?: Slice | Entity;
} & Omit<PageKnowledgeHubLayoutProps, 'entity'>;

export const SliceKnowledgeHubLayout: Shapeable.FC<SliceKnowledgeHubLayoutProps> = (props) => {
  const { className, entity, entityTypes = {}, ...layoutProps } = props;

  const posts = usePosts();
  const feedEntries = useFeedEntries();
  const videos = useVideos();

  const readsItems = useMemo(() => {
    const items = [...posts, ...feedEntries, ...videos];
    const [withoutPublished, withPublished] = partition(items, (item) => !item.published);
    return [...reverse(sortBy(withPublished, 'published')), ...withoutPublished];
  }, [posts, feedEntries, videos]);

  return (
    <PageKnowledgeHubLayout
      className={cls.name(className)}
      entity={entity}
      {...layoutProps}
      entityTypes={{
        ...entityTypes,
        Entity: {
          ...entityTypes.Entity,
          items: readsItems,
        },
      }}
    />
  );
};

SliceKnowledgeHubLayout.cls = cls;
